import { render, staticRenderFns } from "./carousel_images.vue?vue&type=template&id=57cc9978&scoped=true&"
import script from "./carousel_images.vue?vue&type=script&lang=js&"
export * from "./carousel_images.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cc9978",
  null
  
)

export default component.exports